import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from '../../../../services/common.service';
import {ExcelService} from '../../../../services/excel.service';
import {ReportService} from '../../../../services/report.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {CustomFormsHistoryDetailsDialogComponent} from './custom-forms-history-details-dialog/custom-forms-history-details-dialog.component';

@Component({
  selector: 'app-custom-form-completed',
  templateUrl: './custom-form-completed.component.html',
  styleUrls: ['./custom-form-completed.component.scss']
})
export class CustomFormCompletedComponent implements OnInit, AfterViewInit {
  uniqueId: string;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private reportService: ReportService,
              public router: Router,
              public excelService: ExcelService,
              public dialog: MatDialog,
              public route: ActivatedRoute,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
  }
  forms: MatTableDataSource<any> = new MatTableDataSource<any>();
  originalForms = [];
  isLoading;
  displayColumns = ['title', 'published_at', 'modified_by_displayName', 'modified_at', 'isChecked', 'actions'];

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.uniqueId = params.formUniqueId;
      console.log(this.uniqueId);
    });
  }

  async ngAfterViewInit() {
    await this.initializeForms();
  }

  async initializeForms() {
    try {
      const forms = [];
      const formsRequest = await this.reportService.getCustomFormsReport(1, this.uniqueId);

      for (const form of formsRequest) {
          form.displayName = `${form.child_first_name} ${form.child_last_name}`;
          form.modified_by_displayName = form.modified_by ?  `${form.modified_by_first_name} ${form.modified_by_last_name}` : '-';
          if (forms.findIndex(f => f.form_unique_id === form.form_unique_id && f.child_id === form.child_id) === -1) {
            forms.push(form);
          } else {
            this.originalForms.push(form);
          }
      }

      this.forms = new MatTableDataSource<any>(forms);
      this.forms.sort = this.sort;
    } catch (e) {
      console.log(e);
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φορτώσουμε τις ολοκληρωμένες φόρμες');
    } finally {
      this.isLoading = false;
    }
  }

  search(value: any) {
    this.forms.filter = value.trim().toLowerCase();
  }

  async editForm(form) {
    const inputConfig = {
      edit: true,
      childId: form.child_id,
      mode: false,
      parentId: form.notification_to_parent,
      unique_id: form.form_unique_id,
      version: 'latest'
    };
    console.log(inputConfig);
    await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
  }

  getHistoryCount(form) {
    const displayForms = this.originalForms.filter(f => f.child_id === form.child_id);
    return displayForms.length;
  }

  async showHistory(form) {
    const displayForms = this.originalForms.filter(f => f.child_id === form.child_id);
    this.dialog.open(CustomFormsHistoryDetailsDialogComponent, {
      data: {
        displayForms
      }
    });
  }

  async checkForm(form, status) {
    try {
      console.log('=== checkForm START ===');
      console.log('form:', form);
      console.log('form.id:', form.id);
      console.log('status:', status);
      const result = await this.reportService.validateChildForm(form.id, status);
      console.log('validateChildForm result:', result);
      await this.initializeForms();
      this.toastMessagesService.toastSuccessMessage('Η επιβεβαίωση ενημερώθηκε');
      console.log('=== checkForm END ===');
    } catch (e) {
      console.error('=== checkForm ERROR ===', e);
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async exportToExcel(form) {
    const uniqueFormId = form.form_unique_id;

    try {
      const data = await this.reportService.getDataToExportByIdAndUniqueId(form.id, uniqueFormId);

      const columns = this.commonService.formatColumns(data[0]);
      const resultData = [];
      for (const d of data) {
        resultData.push(this.commonService.formatData(d));
      }
      this.excelService.exportAsCustomExcelFile(resultData, form.displayName, columns);

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
